<template>
  <div class="tags" :class="sideTitle!==undefined&&'tags_sideTitle'">
      <div class="caption tags__title" v-if="hideTitle===undefined">Теги:</div>
      <div class="tags__container" :class="lineMode!==undefined&&'tags__container_line'">
        <chip v-for="(v, k) in localTags" :key="k" class="tags__tag text-no-wrap" :color="v.tag.color"><span :style="`color:${$tools.getContrastColor(v.tag.color)}`">{{v.tag.name}}</span></chip>
      </div>
  </div>
</template>

<script>
import State from "@/plugins/state";
import Chip from "@/componentsV2/base/Chip.vue";


import {
  Entity_Tag,
  Entity_TagLink,
  Entity_User,
  Entity_MedPlan
} from "../../../../EntityStoreCacheService";

export default {
  components: {Chip},
  props:['tags', 'entityType', 'sideTitle', 'hideTitle', 'lineMode'],
  data:()=>({
    localTags: [],
    loadState: new State(),
    items:[],
  }),
  mounted() {
    if (this.tags!==undefined) {
      this.localTags = this.tags.filter(i=>i.status!=='inactive');
    } else {
      this.tagLinksLoad(); 
    }
  },
  watch:{
    entityId(v){
      if(v!==undefined)
        this.tagLinksLoad(); 
    }
  },
  methods: {
    tagLinksLoad() {
      let rb = new Entity_TagLink()
       .selects(Entity_TagLink.id)
       .selects(Entity_TagLink.endDate)
       .selects(Entity_TagLink.startDate)
       .selects(Entity_TagLink.status)
       .selects(Entity_TagLink.id)
       .selects(Entity_TagLink.id)
       .selects([Entity_TagLink.tag, Entity_Tag.id].join('.'))
       .selects([Entity_TagLink.tag, Entity_Tag.name].join('.'))
       .selects([Entity_TagLink.tag, Entity_Tag.color].join('.'))

        if (this.entityType === 'user')
          rb.filterAnd([Entity_TagLink.entity, Entity_TagLink.user, Entity_User.id].join('.')+'=?',this.entityId);

        if (this.entityType === 'medPlan')
          rb.filterAnd([Entity_TagLink.entity, Entity_TagLink.medPlan, Entity_MedPlan.id].join('.')+'=?',this.entityId);

        rb.filterAnd([Entity_TagLink.entity, Entity_TagLink.status].join('.')+'=?','active');
        rb.page(1).onPage(1000)
        .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
        .request((v)=>{
          this.localTags = v.items;
          // this.localEntityId = user?.id;
        }, (e)=>{
          console.error(e.response.data.message);
          this.loadState.stateError(e)
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.tags {
  &__title {
    margin-bottom: 5px;
  }
  &__tags-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
  }
  &_sideTitle {
    display: flex;
    gap: 0 10px;
  }
  &_sideTitle #{&}__title{
    padding-top: 3px;
    margin-bottom: 0;
    display: flex;
  }
  &__container {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
    &_line {
      flex-wrap: nowrap;
    }
  }
}
</style>